<div class="page-header">
  @if(!isMobile) {
    <h1 class="page-title">My Loads</h1>
  } @else {
    <div class="results-count">
      @if (loading) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        Loads: 
        <span class="ml-3" [class.no-results]="dataSource.data.length === 0">
          {{ dataSource.data.length | number }}
        </span>
      }
    </div>
  }

  <div class="header-actions">

    @if(!isMobile) {
      <div class="results-count">
        @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Loads: 
          <span class="ml-3" [class.no-results]="dataSource.data.length === 0">
            {{ dataSource.data.length | number }}
          </span>
        }
      </div>
    }

    <button mat-icon-button class="refresh-button" (click)="getMyLoads(true)" matTooltip="Refresh" [disabled]="loading">
      <mat-icon>refresh</mat-icon>
    </button>

    <button mat-icon-button class="create-button" (click)="createLoad()" matTooltip="Add New Load" [disabled]="loading">
      <mat-icon>add</mat-icon>
    </button>

  </div>
</div>

<br />

<table mat-table [dataSource]="dataSource" matSort class="results-table">
  <!-- Mobile Column -->
  <ng-container matColumnDef="mobile">
    <th mat-header-cell *matHeaderCellDef></th>

    <td mat-cell *matCellDef="let load">
      <div class="mobile-load-cell">

      <div class="mobile-actions">

        @if (!load.visible) {
          <mat-icon
            class="hidden-icon"
            matTooltip="Hidden"
          >
            visibility_off
          </mat-icon>
        }

        <button
          mat-icon-button
          class="mobile-menu-button"
          [matMenuTriggerFor]="loadMenu"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>more_vert</mat-icon>
        </button>

      </div>

        <mat-menu #loadMenu="matMenu">
          <button mat-menu-item (click)="refreshLoad(load)">
            <mat-icon>refresh</mat-icon>
            <span>Refresh</span>
          </button>

          <button mat-menu-item (click)="matchTruck(load)">
            <mat-icon>search</mat-icon>
            <span>Match Trucks</span>
          </button>

          <button mat-menu-item (click)="updateLoad(load)">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
          </button>

          <button mat-menu-item (click)="copyLoad(load)">
            <mat-icon>content_copy</mat-icon>
            <span>Copy</span>
          </button>

          <button mat-menu-item (click)="toggleVisibility(load)">
            <mat-icon>
              {{ load.visible ? 'visibility_off' : 'visibility' }}
            </mat-icon>
            <span>
              {{ load.visible ? 'Hide' : 'Show' }}
            </span>
          </button>

          <button mat-menu-item (click)="deleteLoad(load)">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>

        <div class="mobile-location-row">
          <span class="location-marker filled"></span>

          <div class="location-text">
            {{ load.origin_city | titlecase }}, {{ load.origin_state }}

            @if (load.origin_start_date === load.origin_end_date) {
              <span class="dates">
                ({{ load.origin_start_date | date: 'MM/dd' }})
              </span>
            } @else {
              <span class="dates">
                ({{ load.origin_start_date | date: 'MM/dd' }} -
                {{ load.origin_end_date | date: 'MM/dd' }})
              </span>
            }
          </div>
        </div>

        <div class="mobile-middle-row">
          <span class="location-connector"></span>

          <span class="middle-text">
            {{ load.distance | number }} mi
          </span>
        </div>

        <div class="mobile-location-row mb-10">
          <span class="location-marker"></span>

          <div class="location-text">
            {{ load.destination_city | titlecase }}, {{ load.destination_state }}

            @if (load.destination_start_date === load.destination_end_date) {
              <span class="dates">
                ({{ load.destination_start_date | date: 'MM/dd' }})
              </span>
            } @else {
              <span class="dates">
                ({{ load.destination_start_date | date: 'MM/dd' }} -
                {{ load.destination_end_date | date: 'MM/dd' }})
              </span>
            }
          </div>
        </div>

        @if (load.rate) {
          <div class="mobile-details">
            <span class="mobile-rate">
              {{ load.rate | currency:'USD':'symbol':'1.0-0' }}
            </span>

            <span class="mobile-rpm">
              ({{ load.rpm | currency:'USD':'symbol':'1.0-2' }} per mi)
            </span>
          </div>
        }

        <div class="mobile-details">
          {{ load.weight | number }} lbs
          <br />
          {{ getDimensions(load) }}
          <br />
          Well Required: {{ toFeetAndInches(load.well_length) }}
        </div>

        <div class="mobile-details">
          Age: {{ formatAge(load.refreshed_since) }}
        </div>

      </div>
    </td>
  </ng-container>

  <!-- Desktop Columns -->
  <ng-container matColumnDef="age">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Age</th>
    <td mat-cell *matCellDef="let element">{{ formatAge(element.refreshed_since) }}</td>
  </ng-container>

  <ng-container matColumnDef="origin_start_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Pickup</th>
    <td mat-cell *matCellDef="let element">
      @if(element.origin_start_date === element.origin_end_date) {
        {{ element.origin_start_date | date: 'MM/dd' }}
      } @else {
        {{ element.origin_start_date | date: 'MM/dd' }} -
        {{ element.origin_end_date | date: 'MM/dd' }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_city">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Origin</th>
    <td mat-cell *matCellDef="let element">{{ element.origin_city }}</td>
  </ng-container>

  <ng-container matColumnDef="origin_state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
    <td mat-cell *matCellDef="let element">{{ element.origin_state }}</td>
  </ng-container>

  <ng-container matColumnDef="destination_start_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Delivery</th>
    <td mat-cell *matCellDef="let element">
      @if(element.destination_start_date === element.destination_end_date) {
        {{ element.destination_start_date | date: 'MM/dd' }}
      } @else {
        {{ element.destination_start_date | date: 'MM/dd' }} -
        {{ element.destination_end_date | date: 'MM/dd' }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="destination_city">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Destination</th>
    <td mat-cell *matCellDef="let element">{{ element.destination_city }}</td>
  </ng-container>

  <ng-container matColumnDef="destination_state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>ST</th>
    <td mat-cell *matCellDef="let element">{{ element.destination_state }}</td>
  </ng-container>

  <ng-container matColumnDef="rate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Rate</th>
    <td mat-cell *matCellDef="let element">
      {{ element.rate | currency:'USD':'symbol':'1.0-0' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="weight">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Weight</th>
    <td mat-cell *matCellDef="let element">
      {{ element.weight | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="dimensions">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Dimensions</th>
    <td mat-cell *matCellDef="let element">
      {{ getDimensions(element) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="well_length">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Well Length</th>
    <td mat-cell *matCellDef="let element">
      {{ toFeetAndInches(element.well_length) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="visible">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Posted</th>
    <td mat-cell *matCellDef="let element">
      {{ element.visible ? 'Yes' : 'No' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>

    <td mat-cell *matCellDef="let element">
      @if (element.expired) {
        <mat-chip>Expired</mat-chip>
      }

      <button
        mat-icon-button
        [matMenuTriggerFor]="loadMenu"
        (click)="$event.stopPropagation()"
      >
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #loadMenu="matMenu">
        <button mat-menu-item (click)="refreshLoad(element)">
          <mat-icon>refresh</mat-icon>
          <span>Refresh</span>
        </button>

        <button mat-menu-item (click)="matchTruck(element)">
          <mat-icon>search</mat-icon>
          <span>Match Trucks</span>
        </button>

        <button mat-menu-item (click)="updateLoad(element)">
          <mat-icon>edit</mat-icon>
          <span>Edit</span>
        </button>

        <button mat-menu-item (click)="copyLoad(element)">
          <mat-icon>content_copy</mat-icon>
          <span>Copy</span>
        </button>

        <button mat-menu-item (click)="toggleVisibility(element)">
          <mat-icon>
            {{ element.visible ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <span>
            {{ element.visible ? 'Hide' : 'Show' }}
          </span>
        </button>

        <button mat-menu-item (click)="deleteLoad(element)">
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" [hidden]="dataSource.data.length === 0"></tr>

  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    class="clickable-row"
    [class.inactive-row]="!row.visible"
    (click)="openLoadDialog(row)"
  ></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="no-results-cell" [attr.colspan]="displayedColumns.length">
      No loads found.
    </td>
  </tr>
</table>

<br />

<mat-paginator
  [style.display]="dataSource.data.length === 0 ? 'none' : ''"
  [pageSize]="itemsPerPage"
  [pageSizeOptions]="[10, 25, 50]"
  showFirstLastButtons>
</mat-paginator>